<jw-modal id='jobEditSelectCustomerModal'>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }

  @if (!this.showSites) {
    <h1 class='header'>Select a customer</h1>
  }

  @if (this.showSites) {
    <h1 class='header'>Select a site</h1>
  }

  <app-grid [hidden]='this.showSites'
    entity='account'
    [filters]='this.filters'
    [columns]='this.columns'
    [buttons]='this.buttons'
    [searchFilters]='this.searchFilters'
    [searchFields]='this.searchFields'
    [amount]='10'
  ></app-grid>

  <app-grid [hidden]='!this.showSites'
    entity='account'
    [filters]='this.filtersSite'
    [columns]='this.columnsSite'
    [buttons]='this.buttonsSite'
    [searchFilters]='this.searchFiltersSite'
    [searchFields]='this.searchFieldsSite'
    [amount]='10'
  ></app-grid>

  <button class='btn btn-danger' (click)='this.cancel()'>Cancel</button>
</jw-modal>
